<template>
  <div
    v-if="memberInfo && memberInfo.child"
    class="member-module memberInfo"
  >
    <h2 class="title">
      {{ $t('message["346"]') }}
      <span
        class="operate"
        @click="handleSpread()"
      >
        <span
          v-if="spread"
          class="text"
        >
          {{ $t('message["1106"]') }}
        </span>
        <span
          v-else
          class="text"
        >
          {{ $t('message["1564"]') }}
        </span>

        <i
          v-if="spread"
          class="iconfont iconicon-test14"
        />
        <i
          v-else
          class="iconfont iconicon-test17"
        />
      </span>
    </h2>
    <div class="item-box">
      <!-- <div
        v-for="(item, index) in memberInfo.child"
        v-show="(item.fieldkey !== 'audit' || !(item.fieldkey === 'audit' && memberInfo.audit_status === 1 && !item.info.userid))"
        :key="index"
        class="item border-bottom-1px"
        :class="{show: showSpread(item)}"
      > -->
      <!--  -->
      <div
        v-for="(item, index) in memberInfo.child"
        :key="index"
        class="item border-bottom-1px"
        :class="{show: spread}"
      >
        <label>{{ item.fieldname }}</label>
        <div
          v-if="showMemberItem(item)"
          class="fieldValue"
        >
          <i
            v-if="(item.fieldkey === 'follow' || item.fieldkey === 'dev') && item.info.truename"
            :class="['is-read', { 'no': !item.info.isread, 'yes': item.info.isread }]"
          />
          <!-- truename -->
          <template>
            <template v-if="item.fieldkey === 'follow'">
              <span v-if="item.info.status === 0">{{ $t('message["394"]') }}</span>
              <span v-else-if="item.info.status === 2 || item.info.status === 4">{{ $t('message["139"]') }}</span>
              <span v-else-if="item.info.status === 3">{{ $t('message["146"]') }}</span>
              <span v-else-if="item.info.status === 5">{{ $t('message["1460"]') }}</span>
              <span
                v-else
                class="truename"
              >{{ item.info.truename || '- -' }}</span>
            </template>
            <em
              v-else
              class="truename"
            >{{ item.info.truename || '- -' }}</em>
          </template>
          <!-- group -->
          <span
            v-if="item.info.rolename || item.info.groupname"
            class="groups fs-gray ml-8"
          >[<em class="rolename">{{ item.info.rolename || '--' }}</em> <em v-if="item.info.groupname && item.info.rolename">/</em> <em class="groupname">{{ item.info.groupname || '' }}</em>]</span>
          <!-- 跟进人员按钮 -->
          <div class="btns">
            <template v-if="item.fieldkey === 'follow'">
              <span
                v-if="permissionInfo.is_show_assign"
                class="btn-text"
                @click="onClickFollow('assign', item)"
              >{{ $t('message["1604"]') }}</span>
              <span
                v-if="permissionInfo.is_show_receive"
                class="btn-text"
                @click="onClickFollow('receive', item)"
              >{{ $t('message["613"]') }}</span>
              <span
                v-if="permissionInfo.is_show_transfer"
                class="btn-text"
                @click="onClickFollow('transfer', item)"
              >{{ $t('message["1645"]') }}</span>
              <span
                v-if="permissionInfo.is_show_allocate"
                class="btn-text"
                @click="onClickFollow('allocate', item)"
              >{{ $t('message["298"]') }}</span>
            </template>
            <div
              v-if="item.info.status === 4 && memberInfo.reallocate_truename"
              class="re-assign"
            >
              <div class="top">
                <span class="time">{{ moment(memberInfo.reallocate_time * 1000).format('YYYY-MM-DD HH:mm:ss') }}</span>
                <span class="truename">{{ memberInfo.reallocate_truename }}</span>
                <span
                  v-if="memberInfo.reallocate_rolename || memberInfo.reallocate_groupname"
                  class="groups fs-gray ml-8"
                >[<em class="rolename">{{ memberInfo.reallocate_rolename || '--' }}</em> <em v-if="memberInfo.reallocate_groupname && memberInfo.reallocate_rolename">/</em> <em class="groupname">{{ memberInfo.reallocate_groupname }}</em>] </span>
                <span>{{ $t('message["1041"]') }}</span>
              </div>
              <div class="content">
                {{ memberInfo.reallocate_reason }}
              </div>
            </div>
            <div
              v-else-if="item.info.status === 5"
              class="archive-desc"
            >
              <span class="time">{{ moment(memberInfo.archive_time * 1000).format('YYYY-MM-DD HH:mm:ss') }} </span>
              <span class="truename">{{ memberInfo.archive_truename }}</span>
              <span
                v-if="memberInfo.archive_rolename || memberInfo.archive_groupname"
                class="fs-gray ml-8"
              >[<em class="rolename">{{ memberInfo.archive_rolename || '--' }}</em> <em v-if="memberInfo.archive_groupname && memberInfo.archive_rolename">/</em> <em class="groupname">{{ memberInfo.archive_groupname }}</em>] </span>
              <span>{{ $t('message["420"]') }} </span>
              <span v-if=" memberInfo.archive_reason">：{{ memberInfo.archive_reason }}</span>
            </div>
          </div>
        </div>

        <div
          v-else
          class="fieldValue string-item"
        >
          <span class="value">
            {{ item.fielddesc || item.fieldvalue }}
          </span>
        </div>
      </div>
    </div>
    <follow-modal
      ref="followModal"
      :visible.sync="showFollowModal"
      :inquiry-id="inquiryId"
      :type="type"
      :current-item="currentItem"
      :groupid="followGroupid"
      :is-shared="memberInfo.is_shared"
      class="follow-modal"
    />
    <follow-cascader
      v-if="sourceDatas.length"
      :visible="showFollowCascaderModal"
      :current-item="currentItem"
      :source-datas="sourceDatas"
      @change="handleChangeCascader"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import FollowModal from './modal/FollowModal'
import FollowCascader from './modal/FollowCascader'
import eventBus from '@/lib/eventBus'

export default {
  components: {
    FollowModal,
    FollowCascader
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      showFollowModal: false,
      showFollowCascaderModal: false,
      type: '',
      currentItem: {},
      sourceDatas: [],
      // memberInfoLocal: {},
      spread: false
    }
  },
  computed: {
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    from () {
      return this.$route.query.from
    },
    inquiryId () {
      return this.$route.params.inquiryId
    },
    followGroupid () {
      const { follow_groupid: followGroupid } = this.memberInfo
      return followGroupid
    }
  },
  watch: {
    memberInfo: {
      handler (val) {
        if (val) {
          const spread = this.getSpread(val)
          this.spread = spread
          // this.memberInfoLocal = val
        }
      },
      immediate: true
    }
  },
  created () {
    eventBus.$on('toggleFollowCascaderModal', this.toggleFollowCascaderModal)
  },
  methods: {
    moment,
    getSpread (memberInfo) {
      const { is_show_assign: isShowAssign, is_show_receive: isShowReceive, is_show_allocate: isShowAllocate } = this.permissionInfo
      const { follow_truename: followTruename } = memberInfo

      if ((isShowAssign || isShowReceive || isShowAllocate) && !followTruename) {
        return true
      }
    },
    onClickFollow (type, item) {
      this.type = type
      this.showFollowModal = true
      this.currentItem = Object.assign({}, item)

      this.loadData(item, type)
    },
    handleSpread () {
      if (this.spread) {
        this.spread = false
      } else {
        this.spread = true
      }
    },
    /* showSpread (item) {
      if (!this.spread) {
        return item.fieldkey === 'input_time' || item.fieldkey === 'input' || item.fieldkey === 'follow'
      }
      return true
    }, */
    showMemberItem (item) {
      return item.fieldkey === 'input' || item.fieldkey === 'dev' || item.fieldkey === 'audit' || item.fieldkey === 'follow'
    },
    toggleFollowCascaderModal (visible) {
      this.showFollowCascaderModal = visible
    },
    handleChangeCascader (data) {
      this.currentItem.valueDesc = data.valueDesc
      this.currentItem.fieldvalue = data.fieldvalue
      this.currentItem.info = data.info
      this.currentItem.submit = data.submit
    },
    async loadData (item = {}, type) {
      const { fieldkey = '' } = item
      const $followModal = this.$refs.followModal
      const data = await $followModal.getData({ fieldkey, inquiryType: type })
      if (data) {
        this.sourceDatas = data
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.member-module.memberInfo {
  background-color: #fff;
  em {
    font-style: normal;
  }
  h2.title {
    line-height: 24px;
    padding: 12px 12px 6px;
    font-size: 14px;
    color: #999;
    // font-weight: bold;
    background-color: #f5f5f5;
  }
  h2 {
    .operate {
      .text {
        color: #5077aa;
      }
      i {
        color: #5077aa;
      }
      float: right;
    }
  }
  .item {
    display: none;
    min-height: 56px;
    margin: 0 12px;
    font-size: 16px;
    &.show {
      display: flex;
    }
    label {
      width: 100px;
      min-height: 32px;
      line-height: 32px;
      padding: 12px 26px 12px 0;
      color: #888;
      word-break: break-all;
    }
    .fieldValue {
      flex: 1;
      // width: 200px;
      padding: 12px 0;
      line-height: 32px;
    }
    .truename {
      vertical-align: middle;
    }
    .groups {
      height: 22px;
      line-height: 22px;
      font-size: 12px;
      vertical-align: middle;
    }
  }
  .btn-text {
    color: $primary-color;
    margin-right: 8px;
    margin-top: 4px;
    display: inline-block;
  }
  .re-assign {
    .content {
      color: $gray2;
      line-height: 1.5;
    }
  }
  .archive-desc,
  .re-assign {
    span.time {
      display: block;
    }
  }
  .is-read {
    display: inline-block;
    position: relative;
    font-size: 0;
    transform: scale(0.5);
    transform-origin: center left;
    &.no {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #4CA0F2;
    }
    &.yes {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      border-radius: 8px;
      background: #D6D6D6;
    }
    /* &.iconfont {
      font-size: 16px;
      color: #D6D6D6;
      vertical-align: middle;
    } */
  }
  .is-read + .truename {
    margin-left: -2px;
  }
}
</style>
